export default __webpack_public_path__ + "static/media/update-progress-outline-16px.f9ea08ff.svg";